/**
 * Contains the analytic event ids we use throughout this library
 */
export const AnalyticsKeys = {
  Action: {
    SUPPORT_CREATION: 'support_email_creation',
  },
} as const;
